import { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import {
    EditButton,
    List,
    ShowButton,
    TextField,
    useTable,
    CreateButton,
} from "@refinedev/antd";
import { format, formatDistanceToNow } from 'date-fns';

import { Space, Table, Button, Form, Input, Select, Typography, Popover, Tooltip } from "antd";
import { debounce } from "lodash";

export const WorkoutsList = () => {
    const { Title } = Typography;
    const [hoveredRow, setHoveredRow] = useState<string>("");

    const handleMouseEnter = (id: string) => {
        setHoveredRow(id);
    };

    const handleMouseLeave = () => {
        setHoveredRow("");
    };

    const { tableProps, searchFormProps } = useTable({
        syncWithLocation: true,
        queryOptions: {
            keepPreviousData: false,
            cacheTime: 20,
        },
        onSearch: (values: any) => {
            return [
                {
                    field: "q",
                    operator: "contains",
                    value: values.q,
                },
            ]
        }
    });

    const handleSearchChange = debounce(() => {
        // console.log("Form change being triggered");
        searchFormProps.form?.submit();
    }, 500);

    return (
        <div style={{ padding: "4px", position: "relative", }}>
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 10,
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "flex-start",
            }}>
                <Form {...searchFormProps} onValuesChange={handleSearchChange}>
                    <Title level={4}>Search</Title>
                    <div style={{ display: "flex", gap: 10}}>
                        <Form.Item name="q">
                            <Input placeholder="Search by name, description" suffix={<SearchOutlined />} />
                        </Form.Item>
                    </div>
                </Form>
            </div>
            <List>
                <Table {...tableProps} rowKey="id">
                    <Table.Column dataIndex="name" title={"Name"} />
                    <Table.Column 
                        dataIndex="description" 
                        title={"Description"} 
                        render={(text) => (
                            <div style={{ maxWidth: '385px' }}>
                                <Tooltip 
                                    title={text}
                                    placement="top"
                                    overlayStyle={{ maxWidth: '385px', maxHeight: '200px', overflow: 'auto' }}
                                >
                                    <Typography.Text ellipsis>
                                        {text}
                                    </Typography.Text>
                                </Tooltip>
                            </div>
                        )}
                    />
                    <Table.Column
                        dataIndex="createdAt"
                        title={"Created At"}
                        render={(value, record) => (
                            <div
                                onMouseEnter={() => handleMouseEnter(record.id)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <Popover content={format(new Date(value), "MM/dd/yy hh:mm a")}>
                                    <span>
                                        {formatDistanceToNow(new Date(value))} ago
                                    </span>
                                </Popover>
                            </div>
                        )}
                    />
                    <Table.Column
                        title={"Actions"}
                        dataIndex="actions"
                        render={(_, record: any) => (
                            <Space>
                                <EditButton hideText size="small" recordItemId={record.id} />
                                <ShowButton hideText size="small" recordItemId={record.id} />
                            </Space>
                        )}
                    />
                </Table>
            </List>
        </div>
    )
} 